import type { ProductPricesWithDiscount } from "@frend-digital/centra-legacy/types/product";

import type { Sizes } from "@/app/product/[product]/components/ActionSection/ActionSection";
import type { CartItem } from "@/lib/hooks/useSelection/cart/useItems";

import { ProductCard } from "../formatters/formatProductCards/formatProductCard";
interface CartItemPDPType {
  name?: string;
  uri?: string;
  variantName?: string;
  sizes?: {
    itemId: string;
    name: string;
  }[];
  prices?: ProductPricesWithDiscount;
  media?: {
    href: string;
    alt: string;
  }[];
}

export const convertProductToCartItem = (
  product: CartItemPDPType,
  itemId: string
): CartItem => {
  const media = (product?.media &&
    product?.media.length > 0 &&
    product?.media[0]) || {
    href: "",
    alt: "",
  };
  return {
    name: product?.name,
    uri: product?.uri,
    id: "",
    variant: product?.variantName,
    size: product?.sizes?.find((size) => size.itemId === itemId)?.name || "",
    itemId: itemId,
    price: product?.prices?.price || "",
    quantity: 1,
    sku: "",
    category: "",
    discountedPrice: product?.prices?.priceBeforeDiscount || "",
    media: {
      standard: {
        href: media.href,
        alt: media.alt,
      },
      full: {
        href: media.href,
        alt: media.alt,
      },
    },
    priceAsNumber: product?.prices?.priceAsNumber,
    line: "",
  };
};

export const convertProductCardToCartItem = (
  product: ProductCard,
  size: Sizes["selectedSize"],
  prices?: ProductPricesWithDiscount
): CartItem => {
  return {
    name: product?.core?.name,
    uri: product?.core?.slug,
    id: "",
    variant: product?.core?.variantName,
    size: size?.name || "",
    itemId: size?.itemId || "",
    price: prices?.price || "",
    sku: "",
    category: "",
    quantity: 1,
    discountedPrice: prices?.priceBeforeDiscount || "",
    media: {
      standard: {
        href: product?.gallery?.image?.href || "",
        alt: product?.gallery?.image?.alt || "",
      },
      full: {
        href: product?.gallery?.image?.href || "",
        alt: product?.gallery?.image?.alt || "",
      },
    },
    priceAsNumber: prices?.priceAsNumber,
    line: "",
  };
};
